import { useState } from 'react';
import { Col, Row } from 'antd';

import SupplyRegionsSelector from '@/views/components/Selectors/SupplyRegionsSelector';
import TrailerStoreIdSelector from '@/views/components/Selectors/TrailerStoreIdSelector';

const LocationSearch = ({ onSearchClick, locationNames, IdOptions, supplyZoneNumberOptions }) => {
  const [selectedSupplyZoneId, setSelectedSupplyZoneId] = useState('');
  const [selectedSupplyZoneName, setSelectedSupplyZoneName] = useState('');
  const [selectedSupplyZoneRegionName, setSelectedZoneRegionName] = useState('');
  const [selectedSupplyZoneNumber, setSelectedSupplyZoneNumber] = useState('');

  const onSupplyZoneIdSelect = (e) => {
    if (e !== undefined) {
      setSelectedSupplyZoneId(e.value);
      onSearchClick(e.value, selectedSupplyZoneName, selectedSupplyZoneRegionName, selectedSupplyZoneNumber);
    } else {
      setSelectedSupplyZoneId('');
      onSearchClick('', selectedSupplyZoneName, selectedSupplyZoneRegionName, selectedSupplyZoneNumber);
    }
  };

  const onSupplyZoneNameSelect = (e) => {
    if (e !== undefined) {
      setSelectedSupplyZoneName(e.label);
      onSearchClick(selectedSupplyZoneId, e.label, selectedSupplyZoneRegionName, selectedSupplyZoneNumber);
    } else {
      setSelectedSupplyZoneName('');
      onSearchClick(selectedSupplyZoneId, '', selectedSupplyZoneRegionName, selectedSupplyZoneNumber);
    }
  };

  const onSupplyZoneRegionSelect = (e) => {
    if (e !== undefined) {
      setSelectedZoneRegionName(e.label);
      onSearchClick(selectedSupplyZoneId, selectedSupplyZoneName, e.label, selectedSupplyZoneNumber);
    } else {
      setSelectedZoneRegionName('');
      onSearchClick(selectedSupplyZoneId, selectedSupplyZoneName, '', selectedSupplyZoneNumber);
    }
  };

  const onSupplyZoneNumberSelect = (e) => {
    if (e !== undefined) {
      setSelectedSupplyZoneNumber(e.label);
      onSearchClick(selectedSupplyZoneId, selectedSupplyZoneName, selectedSupplyZoneRegionName, e.label);
    } else {
      setSelectedSupplyZoneNumber('');
      onSearchClick(selectedSupplyZoneId, selectedSupplyZoneName, selectedSupplyZoneRegionName, '');
    }
  };

  return (
    <Row gutter={20}>
      <Col flex={1}>
        <Row gutter={20}>
          <Col sm={6}>
            <TrailerStoreIdSelector
              label="Filter by Location # / Location ID"
              editMode
              name="locationId"
              placeholder="Location #"
              onChange={onSupplyZoneIdSelect}
              options={IdOptions}
            />
          </Col>

          <Col sm={6}>
            <TrailerStoreIdSelector
              label="Filter by Location Name"
              editMode
              name="locationName"
              placeholder="Location Name"
              onChange={onSupplyZoneNameSelect}
              isIDSelector={false}
              options={locationNames}
            />
          </Col>

          <Col sm={6}>
            <TrailerStoreIdSelector
              label="Filter by Supply Zone"
              editMode
              name="SzNumber"
              placeholder="SupplyZone Number"
              onChange={onSupplyZoneNumberSelect}
              isIDSelector={false}
              options={supplyZoneNumberOptions}
            />
          </Col>

          <Col sm={6}>
            <SupplyRegionsSelector
              label="Filter by Location region name"
              editMode
              name="RegionName"
              margin="m-0"
              placeholder="Region Name"
              onChange={onSupplyZoneRegionSelect}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default LocationSearch;
